var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 ml-auto mr-auto"},[_c('pre',[_vm._v(_vm._s(_vm.InfoData))])])])}
var staticRenderFns = []

export { render, staticRenderFns }